import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { IMChatComp } from "../components/IMChatComp";
import Loader from "../components/Loader";
import { StartHelloComp } from "../components/StartHelloComp";
import UserImage from "../components/UserImage";
import { IMChatMetadata } from "../models/app/IMChatMetadata";
import { RecorderType } from "../models/app/RecorderType";
import { appConfig } from "../models/constants";
import ApiService from "../services/ApiService";
import DbService from "../services/DbService";
import { IMChatStore } from "../stores/IMChatStore";
import { RecorderStore } from "../stores/RecorderStore";
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";
import ActionSheet, { ActionSheetRef } from "actionsheet-react";
import BlockActionSheet from "../components/BlockActionSheet";
import MatchUserActionSheet from "../components/MatchUserActionSheet";
import { MatchDetailsStore } from "../stores/MatchDetailsStore";


const ChatContainerComp = observer((props: { store: IMChatStore }) => {

    const messagesEndRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        props.store.loadChats()
    }, [])

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: 'nearest', inline: 'start' });
        //    if(messagesEndRef.current) {
        //        messagesEndRef.current.scrollTop = messagesEndRef.current!.scrollHeight
        //        console.log('scrolled')
        //        console.log(messagesEndRef.current!.scrollHeight)
        //     }
    })

    switch (props.store.prog) {
        case 'LOADING': return <div style={{
            overflow: 'scroll',
            height: '80%'
        }} ><Loader /></div>

        case 'SUCCESS': return (<div className='relative' style={{
            overflow: 'scroll',
            padding: '0px 8px'
        }}>
            { props.store.convStarted && <div className='flex-column center-both' style={{marginTop: 5}} >
                <h4>SayToMe invites you to the chat</h4>
            </div>}
            <ul >
                {props.store.chatMsgList.map(item => <IMChatComp chat={item} key={item.timestamp} />)}
            </ul>
            <div ref={messagesEndRef} ></div>
        </div>);

        default: return <p>FAILED</p>
    }

})

const ChatInputContainer = observer((props: { chatStore: IMChatStore }) => {

    const chatStore = props.chatStore
    //const recorderStore = props.chatStore.recorderStore
    const inputRef = useRef<HTMLTextAreaElement>(null)

    function sendChat() {
        chatStore.sendChat()
        inputRef.current!.value = ''
    }



    return (<div className='chat-input-container center-justify'>
        {chatStore.convStarted == false ? <StartHelloComp store={chatStore} /> : null}
        <div className='flex-row center-align chat-input-text-container ' style={{ position: 'relative', flexGrow: 1 }} >
            <textarea ref={inputRef} name="" className='input-chat-text' maxLength={appConfig.IM_TEXT_LENGTH}
                disabled={!chatStore.convStarted}
                onChange={e => chatStore.updateChatText(e.target.value)} />
            <p style={{ position: 'relative', right: 5 }} >{props.chatStore.chatText.length}/{appConfig.IM_TEXT_LENGTH}</p>
        </div>
        {/* <ChatRecorderButton chatStore={chatStore} />
        {recorderStore.recordState == 'stop'?<ChatInputAudPlayer srcUrl={recorderStore.srcUrl}></ChatInputAudPlayer>: null} */}
        <div style={{
            width: 10
        }}></div>
        <button className='chat-voice-button' onClick={sendChat} disabled={chatStore.chatText == ''} >
            <i className="material-icons" style={{
                fontSize: 25,
                zIndex: 10
            }}>send</i>
        </button>
    </div>);
})

const IMChatBox = (props: { chatMeta: IMChatMetadata }) => {


    const chatMeta = props.chatMeta
    const [recorderStore] = useState(new RecorderStore(RecorderType.VNOTE))
    const [store] = useState(new IMChatStore(chatMeta))
    const blockRef = useRef<ActionSheetRef>()
    const matchHeadRef = useRef<ActionSheetRef>()

    const [matchDetailsStore] = useState(new MatchDetailsStore(chatMeta.uid))

    useEffect(() => {
        store.loadPubKey()
    })

    useEffect(() => {
        store.subscribeToChat()

        return () => {
            store.unsubscribeFromChat()
        }
    }, [])

    function openMatchHead(){
        matchDetailsStore.loadMatch()
        matchHeadRef.current?.open()
    }

    // useEffect(()=>{
    //     if(DbService.getPubKeyForChat(props.chattingWithUid!) == null){
    //         ApiService.getUser({userName: props.chattingWithUserId!})
    //             .then(resp=>{
    //                 DbService.setPublicKeyForUser(props.chattingWithUid!, resp.data.pubKey)
    //             })
    //     }
    // },[])

    if (chatMeta == null)
        return <div>No User selected</div>

    // function genList(): ReactNode{

    //     const list = []

    //     for(let i =1; i<=100; i++){
    //         if(i%2 == 0)
    //          list.push(<VChatUser/>)
    //         else
    //          list.push(<VChatRecep/>) 
    //     }

    //     return list
    // }

    return (
        <motion.div className='container absolute' style={{ height: '100%', width: '100%' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >   
            <ActionSheet ref={blockRef} >
                <BlockActionSheet store={store} ref={blockRef.current} />
            </ActionSheet>
            <ActionSheet ref={matchHeadRef} >
                <MatchUserActionSheet matchUid={chatMeta.uid} store={matchDetailsStore} />
            </ActionSheet>
            <div className='flex-row center-align chat-header' style={{justifyContent:'space-between'}}  >
                <div className='flex-row center-align ' >
                    <div onClick={openMatchHead} >
                        <UserImage userName='SB' />
                    </div>
                    <h2 style={{ marginLeft: 10 }} >{chatMeta.userName}</h2>
                </div>
                <p className="material-icons-round" style={{fontSize: 30, cursor: 'pointer' }} onClick={()=>blockRef.current?.open()} >
                    block
                </p>
            </div>
            <ChatContainerComp store={store} />
            <ChatInputContainer chatStore={store} />

        </motion.div>
    )

}

export default IMChatBox